import { IControlType, IRadioControl } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';

import { CpControl } from './cp-control';
import { CpModelService } from '../../cp-model.service';
import { some, findIndex } from 'lodash-es';

export interface IRadioButton {
    dataBinding: DataBinding;
    readonly: boolean;
    title: string;
}

export class CpRadioControl extends CpControl {
    readonly controlTypeGroup = 'Radio';

    readonly buttons!: IRadioButton[];

    readonly defaultIndex: number;

    constructor(control: IRadioControl, dataBindingContext?: DataBinding) {
        super(control);

        this.defaultIndex = control.config.findIndex((rad) => rad.default);

        this.buttons = control.config.map((config) => {
            return {
                dataBinding: new DataBinding(config.dataBinding, dataBindingContext),
                readonly: config.readOnly,
                title: config.title,
            };
        });
    }

    canAlignToBottom() {
        return false;
    }

    getHeightHint() {
        if (this.isVertical()) {
            return this.buttons.length === 0 ? 21 : this.buttons.length * 34 + 8.39;
        }

        return 34;
    }

    isVertical() {
        return this.controlType === IControlType.VerticalRadio;
    }

    getInitialValue(modelService: CpModelService) {
        const values = this.buttons.map((btn) =>
            modelService.getEntity(btn.dataBinding.entity, true)?.getPropertyValue(btn.dataBinding.propertyName)
        );
        const trueIndex = findIndex(values, (v) => !!v);

        return trueIndex === -1 ? this.defaultIndex : trueIndex;
    }

    onModelChange(modelService: CpModelService, modelIndex: number, emitEvent = true) {
        const changes = this.buttons.map((button, index) => {
            const value = index === modelIndex;
            modelService.setValue(button.dataBinding, value, { emitEvent });
        });

        return some(changes);
    }
}
